import { BaseballIcon, BasketballIcon, SoccerIcon } from "@roman/shared/components/Icons";
import type { SportIcon } from "@roman/shared/types/SportIcon";

export type League = {
  seasonId: string;
  name: string;
};

export type Sport = {
  id: number;
  icon: React.FC<SportIcon>;
  title: string;
};

export const SPORTS: Sport[] = [
  {
    id: 1,
    icon: SoccerIcon,
    title: "サッカー",
  },
  {
    id: 2,
    icon: BaseballIcon,
    title: "野球",
  },
  {
    id: 3,
    icon: BasketballIcon,
    title: "バスケットボール",
  },
];
